import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/format';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, error, hint, className, id, rows = 3, ...rest },
  ref,
) {
  const textareaId = id || `textarea-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={textareaId} className="block text-small font-medium text-ink mb-1.5">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        id={textareaId}
        rows={rows}
        className={cn('input resize-y min-h-[80px]', error && 'input-error', className)}
        {...rest}
      />
      {error && <p className="mt-1.5 text-caption text-danger">{error}</p>}
      {!error && hint && <p className="mt-1.5 text-caption text-ink-subtle">{hint}</p>}
    </div>
  );
});
